import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import Character from "../../mechanics/characters/Character"
import { Warrior } from "../../mechanics/characters/Warrior"
import { ICurrensies } from "../../mechanics/inventory/Inventory"
import { Armor, initArmor } from "../../mechanics/items/Armor"
import { initWeapon, Weapon } from "../../mechanics/items/Weapon"

export interface IinitialState {
    character: Character
    inventoryLength: number
    currensy: ICurrensies
    showCurrensy: boolean
    isEquipmentChange: boolean
    isBuyOrSellItem: boolean
}

const initialState: IinitialState = {
    character: new Warrior({
        initHp: 25,
        initAttack: 0,
        initIsNpc: false,
        initName: "name",
        initImgSmall: { webp: 'string', img: 'string' },
        initImgBig: { webp: 'string', img: 'string' },
        initConstitution: 10,
        initDexterety: 10,
        initStrength: 10,
        initCharm: 10,
        initIntelligent: 10,
        initWisdom: 10,
        initGold: 300,
        initSkills: [],
        initEquipment: { armor: new Armor(initArmor), weapon: new Weapon(initWeapon) }
    }),
    inventoryLength: 0,
    currensy: {},
    showCurrensy: false,
    isEquipmentChange: false,
    isBuyOrSellItem: false
}

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setPlayerCharacter(state, action: PayloadAction<Character>) {
            state.character = action.payload
        },
        setInventoryLength(state) {
            state.inventoryLength = state.character.getInventory().getItems().length
        },
        switchInventory(state, action: PayloadAction<boolean>) {
            state.showCurrensy = action.payload
        },
        setIsEquipmentChange(state, action: PayloadAction<boolean>) {
            state.isEquipmentChange = action.payload
        },
        setIsBuyOrSellItem(state) {
            state.isBuyOrSellItem = !state.isBuyOrSellItem
        }
    }
})

export default userSlice.reducer
